import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeColorVariable, ThemeFontSizeVariable, ThemeFontVariable, ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Button as ChakraButton, Link as ChakraLink, } from '@chakra-ui/react';
const sx = {
    fontFamily: ThemeFontVariable.Body,
    fontSize: ThemeFontSizeVariable.Medium,
    color: ThemeColorVariable.OnSurface,
    py: ThemeSpaceVariable.Small,
    px: ThemeSpaceVariable.Medium,
    fontWeight: 'medium',
    // "Reset" styles:
    textDecoration: 'none',
    userSelect: 'none',
    height: 'auto',
    borderRadius: 0,
    textAlign: 'left',
    background: 'transparent',
    outline: 'none',
    lineHeight: 'auto',
    border: 0,
    // Pseudo styles:
    _disabled: {
        opacity: 0.48,
    },
    _hover: {
        bg: ThemeColorVariable.AccentHoverAlpha,
        cursor: 'pointer',
        _disabled: { bg: 'none', cursor: 'not-allowed' },
    },
    _active: {
        bg: ThemeColorVariable.AccentActiveAlpha,
    },
};
/**
 * Link element to be used within NavigationList.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/navigation-list
 */
export function NavigationListLink({ children, display = 'block', w = '100%', minW = 'auto', minH = 'auto', to = undefined, href = undefined, isDisabled, ...props }) {
    return (_jsx("li", { children: _jsx(ChakraLink, { sx: sx, w: w, minW: minW, minH: minH, display: display, to: to, href: isDisabled ? undefined : href, "aria-disabled": isDisabled, ...props, children: children }) }));
}
/**
 * Button element to be used within NavigationList.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/navigation-list
 */
export function NavigationListButton({ children, display = 'block', w = '100%', minW = 'auto', minH = 'auto', ...props }) {
    return (_jsx("li", { children: _jsx(ChakraButton, { sx: sx, w: w, minW: minW, minH: minH, display: display, type: "button", ...props, children: children }) }));
}
//# sourceMappingURL=navigation-list-item.js.map